import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.services';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import AddOnBillingSettings = Components.Schemas.AddOnBillingSettings;

@Component({
	selector: 'app-save-changes-dialog',
	templateUrl: './save-changes-dialog.component.html',
	styleUrls: ['./save-changes-dialog.component.scss'],
	imports: [
		MatProgressSpinner,
		MatDivider,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
	],
})
export class SaveChangesDialogComponent {
	errorSavingChanges: boolean = false;
	confirmDisabled: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: SaveChangesDialogData,
		private readonly dialogRef: MatDialogRef<SaveChangesDialogData>,
		private readonly apiService: ApiService
	) {}

	async onConfirmClicked() {
		if (this.confirmDisabled) {
			return;
		}
		this.confirmDisabled = true;
		await this.apiService
			.updateBillingContract(this.data.id, {
				addOnBilling: this.data.reqBody.addOnBilling,
				billingStartDate: this.data.reqBody.billingStartDate,
				isMonthlyAutoRenewed: this.data.reqBody.isMonthlyAutoRenewed,
			})
			.then((res) => {
				this.dialogRef.close(true);
			})
			.catch((err) => {
				this.errorSavingChanges = true;
			});
	}

	onCloseClicked(): void {
		this.dialogRef.close(false);
	}
}

export interface SaveChangesDialogData {
	id: string;
	reqBody: {
		addOnBilling: AddOnBillingSettings;
		billingStartDate: string;
		isMonthlyAutoRenewed: boolean;
	};
}
